import React from 'react';
import { useTranslation } from 'react-i18next';

const UasComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.uas_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>UAS Type</th>
            <td>{t(`uas.${report.uas_type.toLowerCase()}`)}</td>
          </tr>
          <tr>
            <th>Size</th>
            {report.size ? (
              <td>{t(`size.${report.size.toLowerCase()}`)}</td>
            ) : (
              <td>{t('size.unknown')}</td>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UasComponent;
